import React, { useContext } from 'react';
import { Grid, TextField, Button } from '@mui/material';
import { warehousesContext } from 'views/Admin/Warehouses/WarehousesContext';
import { SearchOutlined as SearchIcon, AddOutlined as AddIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';


let Filters = () => {
    let service = useContext(warehousesContext);


    return (
        <>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    value={service.search.fullText}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        fullText: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.doSearch(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color="inherit"
                    component={Link}
                    to={'/admin/warehouse/addnew'}
                >
                    <AddIcon />&nbsp;Add New
                </Button>
            </Grid>
        </>
    );
}

export default Filters;